import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      border: "1px solid #E0E0E0",
      borderRadius: 4,
      "& .MuiPaper-root": {
        maxWidth: "50vw",
        width: "844px",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        paddingTop: 24
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    rowFlex: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    dialogHeader: {
      padding: "2rem 24px 2rem",
      textAlign: "center",
      text: "20px"
    },
    tableResult: {},
    dialogBottom: {
      margin: "auto"
    },
    title: {
      fontSize: "20px",
      color: "#333",
      marginBottom: "8px"
    },
    btnAction: {
      height: 48,
      width: 240
    },
    tooltip: {
      zIndex: 999,
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      },
      borderRadius: 4,
      background: "#333333",
      padding: "4px 8px"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5,
      fontSize: 14
    },
    MarginTop: {
      marginTop: "0px !important",
      marginBottom: "none"
    },
    required: {
      color: theme.palette.error.main,
      marginLeft: 1,
      "& :after": {
        content: "*"
      }
    }
  }),
  { name: "PriceNotFoundPopup" }
);

export default useStyles;
